import React, {useContext} from "react"

import {AppContext} from "../components/context/AppContext"

export const SheerIdIFrameNurseAndTeacher = (/*props*/) => {
  const {state} = useContext(AppContext)
  const nurseOrTeacherOfferIds = [268645, 268646, 268647]

  let iFrameSrc = state.campaign.iFrameExperienceOneUrl //https://offers.sheerid.com/tmobile/staging/NurseTeacherOptionHere/?offerId=OfferIdHere&submitId=ISubmitIdHere"
  iFrameSrc = iFrameSrc.replace("ISubmitIdHere", state.iSubmission.iSubmitId)

  if(state.campaign.offerId === nurseOrTeacherOfferIds[0]){
      iFrameSrc = iFrameSrc.replace("OfferIdHere", nurseOrTeacherOfferIds[0])
      if(state.nurseOrTeacher === "nurse"){
        iFrameSrc = iFrameSrc.replace("NurseTeacherOptionHere", "medical")
      }
      else{
        iFrameSrc = iFrameSrc.replace("NurseTeacherOptionHere", "teacher")
      }
    }
  else if(state.campaign.offerId === nurseOrTeacherOfferIds[1]){
    iFrameSrc = iFrameSrc.replace("OfferIdHere", nurseOrTeacherOfferIds[1])
      if(state.nurseOrTeacher === "nurse"){
        iFrameSrc = iFrameSrc.replace("NurseTeacherOptionHere", "medical")
      }
      else{
        iFrameSrc = iFrameSrc.replace("NurseTeacherOptionHere", "teacher")
      }
    }
  else{
      iFrameSrc = iFrameSrc.replace("OfferIdHere", nurseOrTeacherOfferIds[2])
      if(state.nurseOrTeacher === "nurse"){
        iFrameSrc = iFrameSrc.replace("NurseTeacherOptionHere", "medical")
      }
      else{
        iFrameSrc = iFrameSrc.replace("NurseTeacherOptionHere", "teacher")
      }
    }

  return (
    <section>
      <div className="container hero3">
        <div className="container">
          <div className="row">
            <iframe src={iFrameSrc} className="sheerId" title="Teacher and Nurse Verification">
            </iframe>
          </div>
        </div>
      </div>
    </section>
  )
}

SheerIdIFrameNurseAndTeacher.propTypes = {
  //iFrameUrl: PropTypes.string
}

SheerIdIFrameNurseAndTeacher.requiresAuth = true 
